export default __webpack_public_path__ + "static/screen_1_07-f2388bea95b5589f2e032fa5e08f71bd.svg";